// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import md5 from 'md5';
import './assets/css/index.less'
import './utils/filters'

Vue.prototype.$axios = axios.create({
  // baseURL: 'https://gateway.ntyy888.com',
  baseURL: 'https://t-gateway.ntyy888.com',
  headers: {
    'appSource': 'lsg',
    'appVer': 101,
    'deviceId': 'h5',
    'channel': 'h5',
    // 'channel2': '2',
    'brand': 'h5',
    'os': '0',
  }
})


Vue.prototype.$axios.interceptors.request.use(function(config) {
  console.log(config)
  // Do something before request is sent
  const headers = config.headers

  const timestamp = Date.now()
  console.log(config)
  // const MY_KEY = "a9e8fh34wf^&(%@&@HJK28JKFHr23e423!@34RNwe";
  const MY_KEY = '34qkgnggvdfg@Q#@#YUR323hrwh';
  const md5str = md5(
    headers['brand'] +
    timestamp +
    headers['appSource'] +
    headers['appVer'] +
    headers['deviceId'] +
    headers['channel'] +
    headers['os'] +
    MY_KEY);

  config.headers['timestamp'] = timestamp
  config.headers['sign'] = md5str.slice(10, 20)
  return config;
}, function(error) {
  // Do something with request error
  return Promise.reject(error);
});

Vue.config.productionTip = false

Vue.prototype.$isIOS = function iOS() {
  return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    ||
    (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}


Vue.prototype.$native = (function() {
  function setupWKWebViewJavascriptBridge(callback) {
    if (window.WKWebViewJavascriptBridge) { return callback(WKWebViewJavascriptBridge); }
    if (window.WKWVJBCallbacks) { return window.WKWVJBCallbacks.push(callback); }
    window.WKWVJBCallbacks = [callback];
    window.webkit.messageHandlers.iOS_Native_InjectJavascript.postMessage(null)
  }
  if (window.webkit) {
    // setupWKWebViewJavascriptBridge(function(bridge) {
    /* Initialize your app here */
    // bridge.registerHandler('testJavascriptHandler', function(data, responseCallback) {
    //     console.log('iOS called testJavascriptHandler with', data)
    //     responseCallback({ 'Javascript Says':'Right back atcha!' })
    // })
    // Vue.prototype.$native.bridge = bridge;
    // bridge.callHandler('testiOSCallback', {'foo': 'bar'}, function(response) {
    //     console.log('JS got response', response)
    // })
    // })
    try {
      setupWKWebViewJavascriptBridge(function(bridge) {
        /* Initialize your app here */
        // bridge.registerHandler('testJavascriptHandler', function(data, responseCallback) {
        //     console.log('iOS called testJavascriptHandler with', data)
        //     responseCallback({ 'Javascript Says':'Right back atcha!' })
        // })
        Vue.prototype.$native.bridge = bridge;
        // bridge.callHandler('testiOSCallback', {'foo': 'bar'}, function(response) {
        //     console.log('JS got response', response)
        // })
      })
    } catch (error) {
      console.log(error)
    }
  }

  return {
    // 立即办卡按钮
    openVip: function() {
      if (window.webkit) {
        Vue.prototype.$native.bridge.callHandler('openVip')
      } else if (window.android && window.android.openVip) {
        window.android.openVip()
      }
    },
    // 退款后返回主页
    BackToRootVC: function() {
      if (window.webkit) {
        Vue.prototype.$native.bridge.callHandler('BackToRootVC')
      } else if (window.android && window.android.BackToRootVC) {
        window.android.BackToRootVC()
      }
    }
  }
})()

router.beforeEach((to, from, next) => {
  // console.error("main.js")
  // console.error(to)
  // console.error(from)
  next()
})

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js